import { split, join } from 'lodash';

import { Nullable } from '~globals/types';
import { AdminVehicleImporter } from '~services/admin/vehicle/types';
import { ApiTransactionVehicle } from '~services/apiTransaction/types';
import { VehicleBase } from '~services/vehicle/types';
import { pluralize } from '~utils/commons';

export const parseSkillsStringToArray = (skills?: Nullable<string>): string[] =>
  skills ? split(skills, ',') : [];

export const parseSkillListToString = (skillsList: string[]): string =>
  join(skillsList, ',');

export const getImporterVehiclesFromCSVAlertDescription = ({
  importedRows,
  totalRows,
  errorRows,
}: AdminVehicleImporter): string | string[] => {
  let text: string | string[] = `Se ${pluralize({
    singular: 'importó',
    plural: 'importaron',
    count: importedRows,
  })} ${pluralize({
    singular: 'vehículo',
    count: importedRows,
    includeCount: true,
  })} correctamente`;

  if (errorRows >= 1) {
    const sendCustomersText = `Se ${pluralize({
      singular: 'envió',
      plural: 'enviaron',
      count: totalRows,
    })} ${pluralize({
      singular: 'vehículo',
      count: totalRows,
      includeCount: true,
    })}`;

    const successCustomersImported = ` ${importedRows} se ${pluralize({
      singular: 'importó',
      plural: 'importaron',
      count: importedRows,
    })} correctamente`;

    const errorsCustomersImported = `${errorRows} se ${pluralize({
      singular: 'importó',
      plural: 'importaron',
      count: errorRows,
    })} con errores`;

    text = [
      sendCustomersText,
      successCustomersImported,
      errorsCustomersImported,
    ];
  }

  return text;
};

export const convertApiTransactionVehicleToVehicleBase = (
  currentVehicle: ApiTransactionVehicle,
): VehicleBase => ({
  id: currentVehicle.vehicleId,
  displayName: currentVehicle.name,
  code: currentVehicle.referenceCode,
  color: currentVehicle.color,
  enabled: currentVehicle.enabled,
});
